var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"fill-height",style:(_vm.backgroundStyle)},[_c('v-content',[_c('v-container',{attrs:{"fluid":""}},[_c('router-view')],1)],1),_c('footer-bar')],1)}
var staticRenderFns = []

export { render, staticRenderFns }